import { render, staticRenderFns } from "./ModalConfirmarNovoTokenCallback.vue?vue&type=template&id=083fd3dc&scoped=true&"
import script from "./ModalConfirmarNovoTokenCallback.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmarNovoTokenCallback.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmarNovoTokenCallback.vue?vue&type=style&index=0&id=083fd3dc&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fd3dc",
  null
  
)

export default component.exports